import React from "react"
import {
    Autocomplete,
    Box,
    Chip,
    TextField,
    Typography,
} from "@mui/material"

const inputStyle = {
    '&.MuiInputBase-root': {
        height: 38,
        padding: '0 8px',
    },
    '& input': {
        padding: '8px 0',
        fontSize: '13px',
    },
}

const LanguageMultiSelect = ({
    label,
    placeholder,
    options = [],
    value = [],
    onChange,
    groupBy,
    readOnly = false,
}) => {
    const handleDelete = (itemToRemove) => {
        if (readOnly) return
        const updated = value.filter((val) => val !== itemToRemove)
        onChange(updated)
    }

    return (
        <Box sx={{ mb: 2 }}>
            {label && (
                <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
                    {label}
                </Typography>
            )}
            <Autocomplete
                multiple
                options={options}
                value={value}
                onChange={(e, newValue) => !readOnly && onChange(newValue)}
                getOptionLabel={(option) => option.label}
                groupBy={groupBy}
                renderTags={() => null}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        placeholder={placeholder}
                        variant="outlined"
                        InputProps={{
                            ...params.InputProps,
                            sx: {
                                '&.MuiInputBase-root': {
                                    height: 38,
                                    fontSize: '13px',
                                    padding: '0px 8px',
                                },
                                '& input': {
                                    fontSize: '13px',
                                    padding: '8px 0',
                                },
                            },
                            readOnly,
                        }}
                        disabled={readOnly}
                        sx={{
                            '& .MuiInputBase-root': {
                                fontSize: '13px',
                            },
                            '& .MuiAutocomplete-input': {
                                fontSize: '13px',
                            },
                        }}
                    />
                )}
                componentsProps={{
                    popper: {
                        modifiers: [
                            {
                                name: 'customStyle',
                                enabled: true,
                                phase: 'beforeWrite',
                                fn: ({ state }) => {
                                    Object.assign(state.elements.popper.style, {
                                        fontSize: '13px !important',
                                    })
                                },
                            },
                        ],
                    },
                }}
                sx={{
                    p: 0,
                }}
                disabled={readOnly}
            />

            {value.length > 0 && (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}>
                    {value.map((option) => (
                        <Chip
                            key={option.label}
                            label={option.label}
                            onDelete={readOnly ? undefined : () => handleDelete(option)}
                            size="small"
                            color={readOnly ? "default" : "primary"}
                            variant={readOnly ? "outlined" : "filled"}
                        />
                    ))}
                </Box>
            )}
        </Box>
    )
}

export default LanguageMultiSelect
